export function initOwl () {
  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    navText: [],
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./static/js/index.js
// module id = null
// module chunks = 